<template>
  <div class="video">
    <iframe
      style="position: relative; z-index: 0; margin: 5% 10%"
      width="80%"
      height="80%"
      :src="sections[sectionCurrent].url"
      frameborder="0"
      wmode="opaque"
      allowfullscreen
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    url: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'baseUrl',
      'sections'
    ]),
    sectionCurrent () {
      return this.$route.params.group
    }
  }
}
</script>

<style lang="scss" scoped>
$mobile-breakpoint: 960px;

div.video {
  background-color: #000;
  padding: 2rem 0 2rem 3rem;
  @media screen and (min-width: $mobile-breakpoint + 1) {
    padding: 4rem 0 4rem 6rem;
  }
  flex-grow: 1;
  flex-basis: 0px;
}
</style>
